// extracted by css-extract-rspack-plugin
export default {"panel":"panel-XMgEOp"};